import axios from '@/plugins/axios';
import _ from 'lodash';

export const state = () => ({
  products: [],
  loading: false,
  filtered: false,
  categories: [],
  brands: [],
  services: [],
});

export const mutations = {
  SET_PRODUCTS(state, payload) {
    state.products = payload;
  },
  SET_LOADING(state, payload) {
    state.loading = payload;
  },
  SET_SERVICES(state, payload) {
    state.services = payload;
  },
  SET_CATEGORIES(state, payload) {
    state.categories = payload;
    state.categories.unshift(
      {
        name: 'All Products',
      },
      {
        name: 'Services',
      }
    );
  },
  SET_SERVICES(state, payload) {
    state.services = payload;
  },
  SET_BRANDS(state, payload) {
    state.brands = payload;
  },
  SET_FILTERED(state, payload) {
    state.filtered = payload;
  },
};

export const actions = {
  async fetchProducts({ commit, rootGetters }, payload = {}) {
    return new Promise((resolve, reject) => {
      var api = 'pos/shops/' + rootGetters['shops/GetShopId'] + '/products';
      // if (payload.query) {
      //   api = api + "?search=" + payload.query;
      // }
      commit('SET_LOADING', true);
      axios
        .get(api, payload)
        .then((res) => {
          commit('SET_PRODUCTS', res.data.data);
          commit('SET_LOADING', false);

          // Set the Filter status
          if (_.isEmpty(payload)) {
            commit('SET_FILTERED', false);
          } else {
            commit('SET_FILTERED', true);
          }
          resolve(res.data.data);
        })
        .catch((err) => {
          commit('SET_LOADING', false);
          reject(err);
        });
    });
  },
  async fetchServices({ commit }) {
    return new Promise((resolve, reject) => {
      axios
        .get(`services`)
        .then((res) => {
          commit('SET_SERVICES', res.data.data);
          resolve(res.data.data);
        })
        .catch((err) => {
          reject(err);
        });
    });
  },
  async fetchServices({ commit, rootGetters }, payload = {}) {
    return new Promise((resolve, reject) => {
      axios
        .get('pos/services/search', payload)
        .then((res) => {
          commit('SET_SERVICES', res.data.data);
          resolve(res.data.data);
        })
        .catch((err) => {
          reject(err);
        });
    });
  },
  async FetchAllCategories({ commit }, payload) {
    return new Promise((resolve, reject) => {
      axios
        .get(`categories?query=${payload}`)
        .then((res) => {
          commit('SET_CATEGORIES', res.data.data);
          resolve(res.data.data);
        })
        .catch((err) => {
          reject(err);
        });
    });
  },
  async FetchAllBrands({ commit }, payload) {
    return new Promise((resolve, reject) => {
      axios
        .get(`pos/brands?query=${payload}`)
        .then((res) => {
          commit('SET_BRANDS', res.data.data);
          resolve(res.data.data);
        })
        .catch((err) => {
          reject(err);
        });
    });
  },
  async fetchUnitAndBatch({ commit, rootGetters }, payload) {
    let id = payload.productId;
    delete payload.productId;
    return new Promise((resolve, reject) => {
      // ;
      axios
        .post(
          'pos/shops/' + rootGetters['shops/GetShopId'] + '/products/' + id,
          payload.selectedUnits
        )
        .then((res) => {
          resolve(res);
        })
        .catch((err) => {
          reject(err);
        });
    });
  },
  async fetchUnitAndBatchWhenUpdateProduct({ commit, rootGetters }, payload) {
    let id = payload.productId;
    delete payload.productId;
    return new Promise((resolve, reject) => {
      axios
        .post(
          'pos/shops/' + rootGetters['shops/GetShopId'] + '/products/' + id,
          payload.selectedUnits
        )
        .then((res) => {
          resolve(res);
        })
        .catch((err) => {
          reject(err);
        });
    });
  },
};

export const getters = {};

export default {
  namespaced: true,
  state,
  mutations,
  actions,
  getters,
};
